class UploadPsdModalController {

    constructor($scope, $uibModalInstance, apiService, campaignId, notificationService) {
        $scope.file = null;
        $scope.processedFile = null;

        $scope.acceptedFileExtensions = ".psd,.zip"
        $scope.fileSelectHint = "PSD or ZIP"
        $scope.isUpdating = false;

        $scope.setProcessed = function (result) {
            console.log(result)
            $scope.processedFile = result;
        };

        $scope.upload = function () {
            if ($scope.processedFile) {
                $uibModalInstance.close($scope.processedFile);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.onDeleted =function(e) {
            console.log("deleted", e)
        }

        $scope.import = function() {
            var fd = new FormData();

            $scope.isLoading = true;
            
            fd.append('file', $scope.file)

            if ($scope.creativeName) {
                fd.append("creativeName", $scope.creativeName);
            }

            notificationService.success(`Importing ${$scope.file.name}, please wait`)

            apiService.post("creative/import/design?campaignId=" + campaignId, fd)
                .then(resp => {
                    notificationService.success(`${$scope.file.name} was imported as ${resp.name} (${resp.id})`)
                    $uibModalInstance.close();
                })
                .catch(resp => {
                    console.error(resp.message)
                    const error = resp?.data?.data?.error ?? `Failed to import ${$scope.file.name}, please try again later`;
                    notificationService.error(error);
                    $uibModalInstance.dismiss('cancel');
                });
        }
    }
}

angular.module('cpm').controller('UploadPsdModalController', [
    '$scope',
    '$uibModalInstance',
    "ApiService",
    'campaignId',
    'NotificationService',
    UploadPsdModalController
]);
